import {Button, LabelRegular, LabelMedium, Avatar} from '@hm/fundamental'
import {mdiOpenInNew} from '@mdi/js'
import {isString} from 'lodash'

import {CommentTextContent} from './CommentTextContent'

type Props = {
  avatarUrl?: string
  userName: string
  date: string
  content: React.ReactNode
  roleLabel?: string
  onOpen?: () => void
}

export const CommentsVersionsViewItem = ({
  avatarUrl,
  userName,
  date,
  content,
  roleLabel,
  onOpen
}: Props) => {
  return (
    <div className="grid grid-cols-[24px_1fr] gap-x-2">
      <div className="self-center">
        {avatarUrl && <img src={avatarUrl} alt="" className="w-full rounded-full" />}
        {!avatarUrl && <Avatar name={userName} />}
      </div>
      <div className="flex justify-between text-foreground items-center gap-x-3 flex-wrap">
        <div className="flex gap-x-[6px] items-center">
          <LabelMedium>{userName}</LabelMedium>
          <span className="text-foreground_faded">&bull;</span>
          <LabelRegular className="text-foreground_faded">{date}</LabelRegular>
        </div>
        {(roleLabel || onOpen) && (
          <span className="flex items-center gap-2">
            {roleLabel && (
              <span className="px-2 py-[2px] rounded-full border border-foreground_faded text-foreground text-xs leading-[18px]">
                {roleLabel}
              </span>
            )}
            {onOpen && (
              <Button
                icon={mdiOpenInNew}
                size="small"
                variant="tertiary"
                square
                type="button"
                aria-label="open-comment-versions"
                onClick={(event) => {
                  event.stopPropagation()
                  onOpen()
                }}
              />
            )}
          </span>
        )}
      </div>
      {/* grid item placeholder for blank space under avatar */}
      <div />
      <div className="text-foreground pt-1">
        {isString(content) ? <CommentTextContent content={content} /> : content}
      </div>
    </div>
  )
}
